import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "round grey4-grey4-background coral-coral-color my-1",
  style: {"height":"3rem","width":"3rem"}
}

import { IonAccordion, IonCol, IonGrid, IonIcon, IonRow } from "@ionic/vue";

import TimerSettings from "@/components/TimerSettings.vue";

import { Reminder } from "@/types/supplier";
import { AddOrderTimerProps } from "@/types/props";

import { addOutline } from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddOrderTimer',
  props: {
    timer: {},
    cssClass: {},
    settings: { type: Boolean },
    gridColor: { default: 'grey4-grey4-background' }
  },
  emits: ["save"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonAccordion), {
    value: "new",
    class: "bg-transparent",
    style: {"overflow":"visible"}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), {
        slot: "header",
        class: _normalizeClass(["timer-entry card-border coral-coral-color fw-b cursor-pointer max-height ion-no-padding light-medium-shadow", __props.gridColor])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), { class: "max-height px-3" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), {
                class: "center-y",
                size: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(addOutline),
                      class: "max-size"
                    }, null, 8, ["icon"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCol), {
                class: "ion-text-center center",
                style: {"padding-left":"5px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('label.newReminder')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCol), {
                class: "center-y",
                size: "auto"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", { style: {"width":"3rem"} }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_unref(IonGrid), {
        slot: "content",
        class: "bg-transparent py-2"
      }, {
        default: _withCtx(() => [
          _createVNode(TimerSettings, {
            "css-class": __props.cssClass,
            timer: __props.timer,
            onSave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save', $event))),
            settings: __props.settings
          }, null, 8, ["css-class", "timer", "settings"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})